import { render, staticRenderFns } from "./cartridge-batch-info.vue?vue&type=template&id=a8e75924&"
import script from "./cartridge-batch-info.vue?vue&type=script&lang=js&"
export * from "./cartridge-batch-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8e75924')) {
      api.createRecord('a8e75924', component.options)
    } else {
      api.reload('a8e75924', component.options)
    }
    module.hot.accept("./cartridge-batch-info.vue?vue&type=template&id=a8e75924&", function () {
      api.rerender('a8e75924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/production-manage/cartridge-batch/cartridge-batch-info.vue"
export default component.exports